import logo from './images/svg/logo.svg';
import logoFeedback from './images/svg/logo_feedback.svg';

export const imagesLogo = {
  logo,
  logoFeedback,
};

export default imagesLogo;
